import { render, staticRenderFns } from "./BardFieldtype.vue?vue&type=template&id=5124101c&"
import script from "./BardFieldtype.vue?vue&type=script&lang=js&"
export * from "./BardFieldtype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports